import { Button, Form, InputNumber, Modal, Select, message } from "antd";
import { useState } from "react";

import { useMutation } from "@tanstack/react-query";
import { addToCategoryAl, addToCategoryM } from "../../../utils/api";

const AddTo = ({ refech, musics, albums, update, row }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const type = Form.useWatch("type", form);

  const { mutate, isLoading } = useMutation(
    async (values) =>
      values?.type === "Music"
        ? await addToCategoryM(values)
        : await addToCategoryAl(values),
    {
      onSuccess: () => {
        messageApi.success(`Added to Subscription Successfully`);
        //reset form
        !update && form.resetFields();

        setVisible(false);
      },
      onError: (err) => {
        messageApi.error(err?.response?.data?.message);
      },
    }
  );

  return (
    <div>
      {contextHolder}
      <Button
        style={{
          width: "200px",
        }}
        type="primary"
        onClick={() => setVisible(true)}
      >
        {update ? "Update" : "Add Music/Album"}
      </Button>
      <Modal
        title={update ? "Update " : "Add   "}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 8 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          initialValues={
            update && {
              title: update.name,
              description: update.description,
              price: update.price,
              validity: update.validity,
              isReward: update.isReward,
              musicRewardCoin: update.musicRewardCoin,
              videoRewardCoin: update.videoRewardCoin,
            }
          }
          defaultValue={{
            type: "Music",
          }}
          onFinish={(values) => {
            console.log(values);

            mutate({
              ...values,
              categoryId: row._id,
            });
          }}
        >
          {/* <Select mode="multiple" placeholder="Select ">
        {musics?.map((item) => (
          <Select.Option key={item._id} value={item._id}>
            {item.name}
          </Select.Option>
        ))}
      </Select> */}{" "}
          <Form.Item label="Type" name="type" required>
            <Select>
              <Select.Option value="Music">Music</Select.Option>
              <Select.Option value="Album">Album</Select.Option>
            </Select>
          </Form.Item>
          {type === "Music" ? (
            <Form.Item label="Music" name="musicId" required>
              <Select placeholder="Select Music">
                {musics?.map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          ) : (
            <Form.Item label="Album" name="albumId" required>
              <Select placeholder="Select Album">
                {albums?.map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <Form.Item
            label="Position"
            name="position"
            required
            rules={[
              {
                required: true,
                message: "Please input your position",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default AddTo;
